import React, {memo} from 'react';
import FAQVideosListItem from "./FAQVideosListItem";
import '../../Styles/FAQ.css'

/**
 * FAQVideosList renders the videos at FAQ Page.
 * @param videoData
 * @returns {JSX.Element}
 * @constructor
 */
const FAQVideosList = ({videoData}) => {

    return (

        <div className='faq-videos-display'>
            {
                videoData.map(video => <FAQVideosListItem key={video.name} videoData={video}/>)
            }
        </div>

    )

}

export default memo(FAQVideosList);